<script>
import {BFormGroup, BFormInput} from 'bootstrap-vue'

export default {
    components: {BFormGroup, BFormInput},
    props: {
        language: {
            type: String,
            required: true,
        },
        question: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            value: this.question,
        };
    },
    methods: {
        emit() {
            this.$emit('input', {question: this.value, language: this.language});
        }
    },
    watch: {
        question() {
            this.value = this.question;
        }
    }
}
</script>

<template>
    <b-form-group
        :label="$t('Component(Label):question')"
        :label-for="'name' + language"
    >
            <b-form-input
                :id="'name' + language"
                v-model="value"
                @input="emit"
                :placeholder="$t('Component(Placeholder):type-here')"
            />
    </b-form-group>
</template>
